import React from "react";
import { Text, View, TouchableOpacity, Modal } from "react-native";
import { FontAwesome6 } from '@expo/vector-icons';
import { useTheme } from './ThemeContext';

export default function HealthWarningModal({ visible, onAcknowledge }) {
  const { themeValues } = useTheme();

  return (
    <Modal
      visible={visible}
      transparent={true}
      animationType="fade"
      onRequestClose={() => {}}
    >
      <View style={{
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 20,
      }}>
        <View style={{
          backgroundColor: themeValues.secondary,
          borderRadius: 16,
          padding: 25,
          marginHorizontal: 20,
          alignItems: 'center',
          maxWidth: 400,
          width: '100%',
        }}>
          <FontAwesome6
            name="heart-pulse"
            size={50}
            color={themeValues.primary}
            style={{ marginBottom: 20 }}
          />
          
          <Text style={{
            color: themeValues.text,
            fontSize: 22,
            fontWeight: '700',
            textAlign: 'center',
            marginBottom: 15,
          }}>
            Health & Safety Notice
          </Text>
          
          <Text style={{
            color: themeValues.muted,
            fontSize: 16,
            lineHeight: 24,
            textAlign: 'center',
            marginBottom: 25,
          }}>
            This meditation app is for relaxation and wellness purposes only. It is not medical advice or a substitute for professional healthcare. 
            {'\n\n'}
            If you have heart conditions, epilepsy, or other health concerns, please consult a healthcare provider before use.
          </Text>
          
          <TouchableOpacity
            style={{
              backgroundColor: themeValues.primary,
              paddingHorizontal: 30,
              paddingVertical: 15,
              borderRadius: 10,
              width: '100%',
              alignItems: 'center',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
            onPress={onAcknowledge}
          >
            <Text style={{
              color: 'white',
              fontSize: 16,
              fontWeight: '600',
              marginRight: 10,
            }}>
              I understand and agree
            </Text>
            <FontAwesome6
              name="check"
              size={16}
              color="white"
            />
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
}
